"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var utils_1 = require("@react-aria/utils");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var ProgressBar_styled_1 = require("./ProgressBar.styled");
exports.ProgressBar = (0, react_1.forwardRef)(function (_a, ref) {
    var progress = _a.progress, accessibleProgressDescription = _a.accessibleProgressDescription, total = _a.total, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'bottom' : _b, barForegroundColor = _a.barForegroundColor, barBackgroundColor = _a.barBackgroundColor, children = _a.children, rest = __rest(_a, ["progress", "accessibleProgressDescription", "total", "labelPosition", "barForegroundColor", "barBackgroundColor", "children"]);
    var _c = (0, core_1.useComponents)(), Strong = _c.Strong, VisuallyHidden = _c.VisuallyHidden;
    var sanitizedProgress = !progress || progress < 0 ? 0 : progress;
    var percentage = !!total ? (sanitizedProgress / total) * 100 : 0; //total cannot be 0, progress can be 0
    var labelId = (0, utils_1.useId)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        labelPosition === 'top' && children && (react_1.default.createElement(ProgressBar_styled_1.ProgressLabel, { "data-testid": "billing-progress-label", marginTop: "2px" },
            react_1.default.createElement(Strong, null, children))),
        react_1.default.createElement(VisuallyHidden, { id: labelId }, accessibleProgressDescription || 'progress bar'),
        react_1.default.createElement(ProgressBar_styled_1.ProgressBackground, __assign({ "data-testid": "billing-progress-bar", role: "progressbar", "aria-valuenow": progress || 0, "aria-valuemax": total || 0, backgroundColorKey: barBackgroundColor, borderColorKey: barForegroundColor, "aria-describedby": labelId, "aria-labelledby": labelId }, rest, { ref: ref }),
            react_1.default.createElement(ProgressBar_styled_1.ProgressForeground, { width: percentage, colorKey: barForegroundColor })),
        labelPosition === 'bottom' && children && (react_1.default.createElement(ProgressBar_styled_1.ProgressLabel, { "data-testid": "billing-progress-label", marginTop: "2px" },
            react_1.default.createElement(Strong, null, children)))));
});
